import React, { SVGProps } from 'react';
export interface IIconProps extends SVGProps<SVGSVGElement> {
  size?: string | number; // TODO: remove this?
}

const Icon = ({
  size = '100%',
  width = size,
  height = size,
  viewBox = '0 0 32 32',
  children,
  ...props
}: IIconProps) =>
  <svg
    width={width}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    // TODO this is default value preserveAspectRatio, if you feel
    // adventurous, test in every browser and remove it xD
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    {children}
  </svg>;

export default Icon;
